export default __webpack_public_path__ + "media/images/steps/step-6-d076927b676c7bd6994132de59570b2b.svg";